
import React, { useEffect, useState } from 'react'
import Footer from '../../CoreComponents/Footer'
import Header from '../../CoreComponents/Header'
import MainHeader from '../../CoreComponents/MainHeader'
import NavBar from '../../CoreComponents/NavBar'
import { formValidation, ManagePromocode, ManageRestaurant, showMessage } from '../../Functionalities/Functions'
import AddTopComponent from '../../CoreComponents/AddTopComponent'
import AddBottomComponent from '../../CoreComponents/AddBottomComponent'
import PromocodeComponent from './Component/PromocodeComponent'
import AdvancedSelctionModal from '../../CoreComponents/AdvancedSelectionModal'
import SingleSectionModal from '../../CoreComponents/SingleSelectionModal'

function Body() {
  const [disable, setdisable] = useState(false)
  const [branchs, setbranchs] = useState({ id: "", name: "", data: [] });
  const [search, setsearch] = useState("");
  const [branchNext, setBranchNext] = useState()
  const [branchPrev, setBranchPrev] = useState()

  const [data, setData] = useState({
    "id": "",
    "code": "",
    "disc_perc": 0.0,
    "flat_disc": 0.0,
    "is_active": '',
    "from_date": "",
    "expiry_date": "",
    "description": "",

    "uplimit": 0,
    "min_amount": 0,

    "recurrence": "",
    "allowed_users": [],
    "applicable_branches": [],
    "is_for_new_user": false,
    "self_pickup_only": false,
  })

  // const [flatDiscount,setFlatDiscount]=useState(false)
  const [discount, setDiscount] = useState(false)
  // void 0

  useEffect(() => {
    getBranches()

  }, [search])

  const getBranches = () => {
    // showMessage("Loading Restaurant", "info", "Loading", "bottom", "bottom-left", 0);
    let params = "page_wise=true&for_dropdown=1&order_by_name=true&is_active=true&blocked_out_drop_down=true&search_text="+search;
    let result = ManageRestaurant("", "", "get", params);
    result
      .then((result) => {
        setbranchs({
          ...branchs,
          data: result.data.results,
        });
        setBranchNext(result.data.next)
        setBranchPrev(result.data.prev)
      })
      .catch((err) => {
        showMessage(JSON.stringify(err), "danger", "Loading error", "top", "top-center", 0);
      });
  };

  useEffect(() => {
  }, [data])

  return (
    <div>
      <div class="content-body">
        <div class="container-fluid">

          <AddTopComponent path={"promocode"}/>

          <div className="col-xl-12 col-lg-12">
            <div className="card">
              <div className="card-body">
                <div className="basic-form">
                  <form>

                    <div className="card-body">
                      <div className="basic-form">

                        <div className="form-row">
                          <div className="form-group col-md-6">
                            <label>Promo Code{" "}<span className="required">*</span></label>
                            <input type="text" className="form-control"
                              value={data.code}
                              onChange={(e) => {
                                setData({ ...data, code: e.target.value })
                              }}

                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Discount percentage</label>
                            <input type="number" className="form-control"
                              value={data.disc_perc}
                              onChange={(e) => {
                                setData({
                                  ...data, disc_perc: e.target.value
                                  , flat_disc: 0.0
                                })
                                setDiscount(true)

                              }}
                              onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                              onWheelCapture={e => {
                                e.target.blur()
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Flat discount</label>
                            <input type="number" className="form-control"
                              value={data.flat_disc}
                              onChange={(e) => {
                                setData({
                                  ...data, flat_disc: e.target.value,
                                  disc_perc: 0.0
                                })
                                setDiscount(false)
                              }
                              }
                              onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                              onWheelCapture={e => {
                                e.target.blur()
                              }}

                            />
                          </div>

                          <div className="form-group col-md-6">
                            <label>Start Date</label>
                            <input type="date"
                              //   min={0}
                              className="form-control"
                              value={data.from_date}
                              onChange={(e) => {
                                setData({ ...data, from_date: e.target.value })
                              }}
                            />
                          </div>

                          <div className="form-group col-md-6">
                            <label>Expiry Date{" "}<span className="required">*</span></label>
                            <input type="date"

                              className="form-control"
                              value={data.expiry_date} required
                              onChange={(e) => {
                                setData({ ...data, expiry_date: e.target.value })
                              }}
                            />
                          </div>
                          <div className="form-group col-md-6">
                            <label>Recurrence{" "}
                              <span className="required">*</span>
                            </label>
                            <input type="number"
                              min={0}
                              className="form-control"
                              value={data.recurrence}
                              onChange={(e) => {
                                setData({ ...data, recurrence: e.target.value })
                              }}
                              onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                              onWheelCapture={e => {
                                e.target.blur()
                              }}
                            />
                          </div>

                          {discount &&
                            <div className="form-group col-md-6">
                              <label>Uplimit
                              <span className="required">*</span>
                              </label>
                              <input type="number"
                                min={0}
                                className="form-control"
                                value={data.uplimit}
                                onChange={(e) => {
                                  setData({ ...data, uplimit: e.target.value })
                                }}
                                onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                onWheelCapture={e => {
                                  e.target.blur()
                                }}
                              />
                            </div>
                          }

                          <div className="form-group col-md-6">
                            <label>Minimum amount{" "}
                              <span className="required">*</span>
                            </label>
                            <input type="number" min={0} className="form-control" value={data.min_amount}
                              onChange={(e) => {
                                setData({ ...data, min_amount: e.target.value })
                              }}
                              onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                              onWheelCapture={e => {
                                e.target.blur()
                              }}
                            />
                          </div >
                          <div className="form-group col-md-6">
                            <label>New Users Only</label>
                            <div className="form-check mt-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={data.is_for_new_user}
                                onChange={(e) => {
                                  setData({ ...data, is_for_new_user: e.target.checked })
                                }}
                              />
                              <label className="form-check-label ml-2">Restricted to new users only</label>
                            </div>
                          </div>
                          <div className="form-group col-md-6">
                            <label>Self-pickup orders only</label>
                            <div className="form-check mt-2">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={data.self_pickup_only}
                                onChange={(e) => {
                                  setData({ ...data, self_pickup_only: e.target.checked })
                                }}
                              />
                              <label className="form-check-label ml-2">Restricted to self-pickup orders only</label>
                            </div>
                          </div>
                          <div className="form-group col-md-12">
                            <label>Description{" "}
                              <span className="required"></span>
                            </label>
                            <textarea type="text"  className="form-control" value={data.description}
                              onChange={(e) => {
                                setData({ ...data, description: e.target.value })
                              }}
                              
                            />
                          </div >

                          <div className="form-group col-md-6">
                            <label>
                              Users
                              {/* <span className="required">*</span> */}
                            </label>
                            {/* <button type="button" class="btn btn-primary form-control mb-2" data-toggle="modal" data-target="#userSelectModal">Select Customers</button> */}
                            <button type="button" class="btn btn-primary light form-control mb-2 mb-2" data-toggle="modal" data-target="#userSelectModal">Select Customer</button>
                            <PromocodeComponent existingUser={[]} customerFunction={(customerID) => setData({ ...data, allowed_users: customerID })} />
                          </div>

                          <div className="form-group col-md-6">
                            <label>
                              Restaurants
                              {/* <span className="required">*</span> */}
                            </label>
                            
                            <button type="button" class="btn btn-primary light form-control mb-2 mb-2" data-toggle="modal" data-target="#SingleSelctionModal">{branchs.name?branchs.name:"Select Restaurant"}</button>
                            
                            <SingleSectionModal
                            search={search}
                            propData={branchs}
                            setData={(id,name)=>setbranchs({...branchs,id:id,name:name})}
                            setSearch={e=>setsearch(e)}
                            // section_type={data.section_type}
                            // object_type={data.object_type}

                            // handleNext={() => handleBranchNext()}
                            // handlePrev={() => handleBranchPrev()}

                            nextValid={false}
                            prevValid={false}
                            />

                            {/* <PromocodeComponent existingUser={[]} customerFunction={(customerID) => setData({ ...data, allowed_users: customerID })} /> */}
                          </div>
                        </div>
                      </div>
                    </div>


                    <AddBottomComponent
                      disable={disable}
                      saveButton={
                        (e) => {
                          e.preventDefault()
                          setdisable(true)
                          var validate = formValidation(data.disc_perc, data.flat_disc, data.min_amount, data.expiry_date, data.from_date, data.code, data.recurrence, data.uplimit)
                          // void 0

                          if (validate === 1) {

                            let res = ManagePromocode(e, {"data": data,branch:branchs.id}, 'add', '')
                            res.then(res => {
                              // void 0
                              setdisable(false)
                              if (res.data.Status === true) {
                                showMessage("Promocode successfully added", "success", "Success!", "top", "top-right", 0)
                                setData({
                                  "id": "",
                                  "code": "",
                                  "disc_perc": 0.0,
                                  "flat_disc": 0.0,
                                  "is_active": '',
                                  "from_date": "",
                                  "expiry_date": "",
                                  "uplimit": 0.0, //shabeeb change
                                  "min_amount": "",
                                  "recurrence": "",
                                  "allowed_users": [],
                                  "applicable_branches": [],
                                  "description": "",
                                  "is_for_new_user": false,
                                  "self_pickup_only": false,
                                })
                                setbranchs({...branchs,id:"",name:""})

                              }
                              else {
                                showMessage(res.data.Error, "danger", "Failed!", "top", "top-right", 0)
                              }
                            }).catch(err => {
                              // void 0
                            })
                          }
                          else {
                            setdisable(false)
                          }
                        }

                      } />


                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function PromocodeAdd() {
  const headers = "Add Promocode";
  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />{" "}
        {/* <Body bo={boln} na={name} nu={num} ar={ary} ob={obj} ao={aryobj} /> */}
        <Body />
        <Footer />
      </div>
    </div>
  );
}

export default PromocodeAdd;
